import React, {FC} from "react";
import {toAbsoluteUrl} from "../AssetHelpers";
import clsx from "clsx";
import Loading from "./Loading";

type props = {
    isLoading?: boolean | false,
    children?: any | null,
    header?: any | null,
    isShowEmpty?: boolean | false,
    className?: string | "",
    label?: string | ""
    labelClass?: string | "text-black",
    def?: boolean
}

const MainCard: FC<props> = ({isLoading, def = false, children, isShowEmpty, header, className, labelClass}) => {
    let content = children;
    if (isLoading) content = <div className="d-flex justify-content-center align-items-center h-100">
        <Loading/>
    </div>
    if (isShowEmpty) content = <div className="d-flex justify-content-center flex-column align-items-center h-100">
        <img className="empty-img" src={toAbsoluteUrl("/media/game/empty.svg")} alt=""/>
        <div className={clsx("t-empty text-black", labelClass)}>Hiện tại không có đơn cược</div>
    </div>
    if (def)
        return <div className={className}>
            {header}
            {content}
        </div>

    return <div className={clsx("content-wrapper", className)}>
        {header}
        {content}
    </div>
}

export default MainCard;